import React, { useCallback, useRef, useState } from "react";
import "./Resource.scss";
import ResourceDataGrid from "../ResourceDataGrid/ResourceDataGrid";
import CreateResource from "../CreateResource/CreateResource";
import ViewResource from "../ViewResource/ViewResource";
import { useUser } from "../../contexts/UserContext";
import { Roles } from "../../Constants/constants";

const Resource = () => {
  const { userRoles } = useUser();

  const [isViewResourcePageVisible, setIsViewResourcePageVisible] = useState(false);
  const [selectedResource, setSelectedResource] = useState(null);

  const resourceGridRef = useRef();

  const handleViewResource = useCallback((e) => {
    setSelectedResource(e.data);
    setIsViewResourcePageVisible(true);
  }, []);

  const refreshResourceGrid = () => {
    resourceGridRef.current.instance.refresh();
  };

  return (
    <div className="ResourceContent">
      <div
        className={isViewResourcePageVisible ? "d-none" : "d-block"}
        style={{ height: "inherit" }}
      >
        <div className="headerForResouce d-flex justify-content-between align-items-center p-2 bg-white">
          <div className="d-flex">
            {userRoles?.includes(Roles.Resource_Manager) && (
              <CreateResource refreshResourceGrid={refreshResourceGrid} />
            )}
          </div>
        </div>
        <div className="datagridForResource">
          <div className="datagridResourceContent h-100">
            <ResourceDataGrid
              handleViewResourceCallback={handleViewResource}
              isViewResourcePageVisible={isViewResourcePageVisible}
              ref={resourceGridRef}
            />
          </div>
        </div>
      </div>
      <div
        style={{ height: "100%" }}
        className={isViewResourcePageVisible ? "d-block" : "d-none"}
      >
        {selectedResource && (
          <ViewResource
            setIsViewResourcePageVisible={setIsViewResourcePageVisible}
            selectedResource={selectedResource}
            setSelectedResourceCallback={setSelectedResource}
          />
        )}
      </div>
    </div>
  );
};
export default Resource;
